import { CONFIG } from '../../../config';
import { getUserFromCookies } from '../../../hooks/useUser';

export const getZendeskWidgetAuthToken = async (): Promise<string | null> => {
  const { accessToken } = getUserFromCookies();

  if (accessToken != null) {
    const response: Response = await fetch(`${CONFIG.MODA_API_URL}/v3.5/zendesk/get_auth_token`, {
      headers: {
        authorization: `Bearer ${accessToken}`,
        'Content-Type': 'text/plain'
      },
      method: 'GET'
    });

    if (response.ok) {
      return await response.text();
    }
  }

  return null;
};
